import { Box, Button, Grid } from '@material-ui/core'
import { Role, roleLabel } from '@types'
import TermsAndConditions from '@views/shared/TermsAndConditions'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { patchProfile, userProfile } from './state/profileSlice'
import RowProfile from '@views/tracking/components/RowProfile'
import EditIcon from '@material-ui/icons/Edit'
import { hasCompletePaymentProfile } from '../../utils/paymentProfile'

const ProfileView: React.FC = () => {
  const { name, email, phone, city, files, document, role, bank, bankDocument, parentName, accountData } = useSelector(
    userProfile
  )
  const [showConditions, setShowConditions] = useState(false)
  const [isEditing, setIsEditing] = useState(false)
  const [modifiedAccountData, setAccountData] = useState(accountData)
  const dispatch = useDispatch()

  useEffect(() => {
    setAccountData(accountData)
  }, [accountData])

  const handleUserProfile = (name: string, value: string) => {
    setAccountData({ ...modifiedAccountData, [name]: value })
  }

  const handleSaveData = () => {
    dispatch(patchProfile({ accountData: modifiedAccountData }))
    setIsEditing(false)
  }

  const isPaymentProfileComplete = hasCompletePaymentProfile(modifiedAccountData)
  return (
    <div className="center_view">
      <Box
        boxShadow="3px 2px 8px 3px light-gray"
        borderRadius="10px"
        border="solid 1px #fc6404"
        width="50%"
        overflow="hidden"
      >
        <Box padding="10px 20px" fontSize="24px" bgcolor="#fc6404" color="white">
          {name}
          <Box fontSize="20px">{roleLabel[role]}</Box>
        </Box>
        <Box padding="20px" justifyContent="center" alignItems="center">
          <Grid container direction="column" spacing={2}>
            <Grid item>
              <strong>Patrocinador: </strong>
              {parentName}
            </Grid>
            <Grid item>
              <strong>Telefono: </strong>
              {phone}
            </Grid>
            <Grid item>
              <strong>Cedula: </strong>
              {document}
            </Grid>
            <Grid item>
              <strong>Email: </strong>
              {email}
            </Grid>
            <Grid item>
              <strong>Ciudad: </strong>
              {city}
            </Grid>
            <Grid item>
              <strong>Banco: </strong>
              {bank}
            </Grid>
            <Grid item>
              <strong>Archivos:</strong>

              {files.map(file => (
                <Grid item>
                  <a className="link" href={file.link} target="_blank">
                    - {file.name}
                  </a>
                </Grid>
              ))}
              {role === Role.admin && bankDocument.length > 1 ? (
                <Grid item>
                  <strong>Solo administrador: </strong>
                  <a className="link" href={bankDocument} target="_blank">
                    - Extracto bancario
                  </a>
                </Grid>
              ) : null}
            </Grid>
            {/* <Grid item>
              <Button
                type="button"
                onClick={() => setShowConditions(true)}
                variant="contained"
                color="primary"
              >
                Ver terminos y condiciones
              </Button>
            </Grid> */}
          </Grid>
        </Box>
      </Box>
      <Box
        boxShadow="3px 2px 8px 3px light-gray"
        borderRadius="10px"
        border="solid 1px #fc6404"
        width="50%"
        overflow="hidden"
        marginTop="1em"
      >
        <Box
          padding="10px 20px"
          fontSize="24px"
          bgcolor="#fc6404"
          color="white"
          display="flex"
          justifyContent="space-between"
        >
          <span>Datos bancarios para pago de comisiones</span>
          <EditIcon
            onClick={() => setIsEditing(true)}
            style={{
              color: '#fff',
              cursor: 'pointer'
            }}
          />
        </Box>
        <Box padding="20px" justifyContent="center" alignItems="center">
          <Grid container direction="column" spacing={2}>
            <RowProfile
              name="bankName"
              handleUserProfile={handleUserProfile}
              showInput={isEditing}
              title="Banco"
              type="select"
              options={['NEQUI', 'BANCOLOMBIA']}
              data={modifiedAccountData?.bankName || ''}
            />
            <RowProfile
              name="accountType"
              handleUserProfile={handleUserProfile}
              showInput={isEditing}
              title="Tipo de cuenta"
              data={modifiedAccountData?.accountType || ''}
            />
            <RowProfile
              name="accountNumber"
              handleUserProfile={handleUserProfile}
              showInput={isEditing}
              title="Numero de cuenta"
              data={modifiedAccountData?.accountNumber || ''}
            />
            <RowProfile
              name="accountDocument"
              handleUserProfile={handleUserProfile}
              showInput={isEditing}
              title="Cédula"
              data={modifiedAccountData?.accountDocument || ''}
            />
            <RowProfile
              name="accountDocumentLink"
              handleUserProfile={handleUserProfile}
              showInput={isEditing}
              title="Link cédula"
              data={modifiedAccountData?.accountDocumentLink || ''}
            />
            <RowProfile
              name="physicalAddress"
              handleUserProfile={handleUserProfile}
              showInput={isEditing}
              title="Dirección física"
              data={modifiedAccountData?.physicalAddress || ''}
            />
            <RowProfile
              name="rutDocument"
              handleUserProfile={handleUserProfile}
              showInput={isEditing}
              title="Link RUT"
              data={modifiedAccountData?.rutDocument || ''}
            />
            {!isEditing && (
              <Grid item>
                <strong>Estado perfil de pago: </strong>
                {isPaymentProfileComplete ? 'Completo' : 'Incompleto'}
              </Grid>
            )}
            {isEditing && (
              <Grid item>
                <Box display="flex" width="100%" justifyContent="flex-end">
                  <Button
                    onClick={handleSaveData}
                    variant="contained"
                    color="primary"
                    disabled={!isPaymentProfileComplete}
                  >
                    Guardar
                  </Button>
                </Box>
              </Grid>
            )}
          </Grid>
        </Box>
      </Box>
      <TermsAndConditions
        open={showConditions}
        onReject={() => setShowConditions(false)}
        onAccept={() => setShowConditions(false)}
        isLoading={false}
      />
    </div>
  )
}

export default ProfileView
